export default " <p>\r\n  withoutocr works!\r\n</p> "